import { $t } from '@/utils';

function makeRedirectCodesSelectItems(codes) {
  return codes.map(code => ({
    text: `message.redirect.${code}.label`,
    value: code,
  }));
}

const config = {
  availableRedirectCodes: [410, 404, 307, 308],
  defaultValue: {
    redirectCode: 404,
  },
};

export function createRedirectFormConfig() {
  return {
    form: [
      {
        fieldsConfig: [
          {
            component: 'NxSelect',
            field: 'redirectCode',
            ignorePopulation: false,
            label: 'redirectCode',
            params: {
              required: true,
              items: makeRedirectCodesSelectItems(config.availableRedirectCodes),
            },
            triggerPopulation: false,
          },
        ],
        title: $t('message.redirect.steps.redirectCode.title'),
      },
      {
        fieldsConfig: [
          {
            component: 'NxNavigationUrl',
            field: 'destination',
            ignorePopulation: false,
            label: 'destination',
            params: {
              showFollow: false,
              allowJsCalls: false,
              excludedTypes: ['empty'],
              showIf: {
                operator: 'in',
                value: [307, 308],
                field: 'redirectCode',
              },
            },
            triggerPopulation: false,
          },
        ],
        title: $t('message.redirect.steps.destination.title'),
      },
    ],
  };
}

export default config;
